export default __webpack_public_path__ + "assets/email-698e944.svg";